import type { NextPage } from 'next';
import dynamic from 'next/dynamic';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import XPowerCompoment from '@/components/XPower';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/x-core-3';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import efBridge from '@/utils/JSBridge';
import { onLogin } from '@/utils/cookie';
import { redirectTo404 } from '@/utils';
import { getAppSession } from '@/utils/appGetToken';

const XCore: NextPage<any> = ({ SEO }) => {
    const { t } = useLang('seo');
    const { isApp } = useGlobal();
    const { locale } = getLocal();
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    if (isApp) {
        // efBridge.registerHandler('getAppMsg', (res) => {
        //     if (!res) return;
        //     const dataSet = {
        //         token: res.token.replace('Bearer ', ''),
        //         user: {},
        //     };
        //     onLogin(dataSet);
        // });
        const token = getAppSession();
        const dataSet = {
            token,
            user: {},
        };
        onLogin(dataSet);
    }

    return (
        <>
            <SEO title={t('title')} description={t('desc')} />
            <SEOlinksA locale={String(locale)} list={seoconfig.include} pathname={seoconfig.url} />
            <GtmPageLoad />
            <PageLayout hideFooter={isApp} hideHeader={isApp} theme="black">
                <XPowerCompoment />
            </PageLayout>
        </>
    );
};

export default XCore;

export async function getStaticProps({ locale }: any) {
    const whiteLocaleList = ['us', 'ca', 'jp', 'eu', 'uk', 'de', 'fr', 'it', 'es'];

    // 非白名单404
    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }
    return {
        props: {},
        revalidate: 18000,
    };
}
